/*global GetAppInfo, TTApplicationEnum */
/*eslint no-undef: "error"*/
import 'moovila-common/dist/polyfills';

import React from 'react';
import ReactDOM from 'react-dom';
import store from './reducers/_store'

import App from './App';

ReactDOM.render(
  <App store={store} />,
  document.getElementById('root')
);

// preload this -- it's borking first time
GetAppInfo(TTApplicationEnum.API);



// WEBPACK FOOTER //
// ./src/index.js